import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/technologies/live-3d-face-ar"
    element={
      <DefaultBusinessLayout
        backgroundImage={require('../../../../assets/images/consumer/technologies/background.jpg')}
      />
    }
  >
    <Route
      path="business/technologies/live-3d-face-ar"
      element={<AsyncPage />}
    />
  </Route>,
];
